export default {
  data () {
    return {
      showData: {},
      EN: {},
      ZH: {},
      CN: {}
    }
  },
  watch: {
    language (newVal) {
      this.showDataHandle(newVal)
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  created () {
    this.showDataHandle(this.$store.state.language)
  },
  methods: {
    showDataHandle (language) {
      if (language === 'en') {
        this.showData = this.EN
      } else if (language === 'zh') {
        this.showData = this.ZH
      } else {
        this.showData = this.CN
      }
    }
  }
}
